<div class="summary-wrapper" 
     *ngIf="!isPaid && !isFailed && !isDeclined && !isVoid; else paymentStatus">
  <div class="main-left">
    <h1>
      <img src="assets/images/long_arrow.svg" alt="long arrow icon" />
      Summary
    </h1>

    <ul class="package-box">
      <li>       
        <p><strong>{{ getInvoiceType(invoiceType) }}</strong></p>
      </li>
    </ul>

    <ul class="price-details">
      <li><span><b>Amount</b></span> <span>AED {{ invoiceAmount }}</span></li>
      <li><b>Total Amount</b><b>AED {{ invoiceAmount }}</b></li>
    </ul>

    <ul>
      <div class="add-card">
        <div class="add_new_card">
          <p>{{ 'AddNewCard' | translate }}</p>
        </div>
        <div style="margin: 15px 0px">
          <div id="card-element"></div>
          <div id="card-errors" role="alert"></div>
        </div>
      </div>
    </ul>

    <button class="btnn" (click)="payOut()" [disabled]="!isCardComplete">Pay Now</button>
  </div>
</div>

<!-- Payment Status Handler -->
<ng-template #paymentStatus>
  <ng-container *ngIf="isPaid" [ngTemplateOutlet]="paymentDone"></ng-container>
  <ng-container *ngIf="isFailed" [ngTemplateOutlet]="paymentFailed"></ng-container>
  <ng-container *ngIf="isDeclined" [ngTemplateOutlet]="paymentDeclined"></ng-container>
  <ng-container *ngIf="isVoid" [ngTemplateOutlet]="paymentVoid"></ng-container>
</ng-template>

<!-- Templates -->
<ng-template #paymentDone>
  <div class="payment-success-container">
    <div class="payment-success-card">
      <div class="payment-icon">✅</div>
      <h2>Payment already completed</h2>
      <p>Thank you! Your invoice has been paid successfully.</p>
    </div>
  </div>
</ng-template>

<ng-template #paymentFailed>
  <div class="payment-failed-container">
    <div class="payment-failed-card">
      <div class="payment-icon">❌</div>
      <h2>Payment Failed</h2>
      <p>Oops! Something went wrong. Please try again.</p>
    </div>
  </div>
</ng-template>

<ng-template #paymentDeclined>
  <div class="payment-declined-container">
    <div class="payment-declined-card">
      <div class="payment-icon">🚫</div>
      <h2>Payment Declined</h2>
      <p>Your transaction was declined. Please use a different payment method.</p>
    </div>
  </div>
</ng-template>

<ng-template #paymentVoid>
  <div class="payment-void-container">
    <div class="payment-void-card">
      <div class="payment-icon">⚠️</div>
      <h2>Payment Voided</h2>
      <p>This transaction has been voided and will not be processed.</p>
    </div>
  </div>
</ng-template>
